import { render } from "./BookBookingResultProcessing.vue?vue&type=template&id=6533d966"
import script from "./BookBookingResultProcessing.vue?vue&type=script&lang=js"
export * from "./BookBookingResultProcessing.vue?vue&type=script&lang=js"
script.render = render

export default script